import client from '@/shared/apis/client'

// 資料の種別。back RecordingImage.Kind と 1:1 (送るときは付けず back が unset = 未設定 にする。付けた後に行の pill で直す)。
// 未設定 と その他 は back では同じ扱い (生成に渡す区別は無い)。「その他」を既定にすると、変えられる所に見えない
// (hub log/108 決定 40)
export type RecordingImageKind =
  | 'unset'
  | 'questionnaire'
  | 'medication_notebook'
  | 'prescription'
  | 'remaining_medication'
  | 'other'

// 種別の 1 語 (行の pill の値)
export const RECORDING_IMAGE_KIND_LABEL: Record<RecordingImageKind, string> = {
  unset: '未設定',
  questionnaire: '問診票',
  medication_notebook: 'お薬手帳',
  prescription: '処方箋',
  remaining_medication: '残薬',
  other: 'その他',
}

// 添付写真 (RecordingImage) — 録音イベント配下のネストリソース。普遍
// (来局/在宅どちらでも添付できる)。back yakureki/views.py RecordingImageView に対応。
export type RecordingImage = {
  id: string
  // 署名付き URL (back が generate_signed_url で返す)。
  image: string
  kind: RecordingImageKind
  created_at: string
}

export const getRecordingImages = async (
  yakurekiId: string
): Promise<RecordingImage[]> => {
  const res = await client.get<RecordingImage[]>(
    `/api/request-events/${yakurekiId}/images/`
  )
  return res.data
}

// 上げるときのファイル名。back は拡張子で MIME を決めて生成に渡す (PDF はそのまま読む)。
export const uploadName = (file: Blob, stem: string): string =>
  `${stem}.${file.type === 'application/pdf' ? 'pdf' : 'jpg'}`

// 署名付き URL のパスが .pdf なら PDF (写真は JPEG に縮めて上げている)。
export const isPdfUrl = (url: string): boolean =>
  new URL(url, window.location.origin).pathname.toLowerCase().endsWith('.pdf')

// 返事を待つ上限。過ぎたら送れなかった扱い (design-book 02-components/attachments-panel.md)
export const UPLOAD_TIMEOUT_MS = 60_000

// 種別は送らない (back が unset = 未設定 にする)。付けた後に行の pill で直す (patchRecordingImageKind)
export const postRecordingImage = async (
  yakurekiId: string,
  image: Blob
): Promise<RecordingImage> => {
  const formData = new FormData()
  formData.append('image', image, uploadName(image, 'attachment'))
  const res = await client.post<RecordingImage>(
    `/api/request-events/${yakurekiId}/images/`,
    formData,
    { timeout: UPLOAD_TIMEOUT_MS }
  )
  return res.data
}

// 種別を直す (体は kind だけ)
export const patchRecordingImageKind = async (
  yakurekiId: string,
  imageId: string,
  kind: RecordingImageKind
): Promise<RecordingImage> => {
  const res = await client.patch<RecordingImage>(
    `/api/request-events/${yakurekiId}/images/${imageId}/`,
    { kind }
  )
  return res.data
}

export const deleteRecordingImage = async (
  yakurekiId: string,
  imageId: string
): Promise<void> => {
  await client.delete(`/api/request-events/${yakurekiId}/images/${imageId}/`)
}
